<template>
  <div id="app">
        
    <div v-if="showModal" id='modal-container' @keyup.esc="showModal = false" tabindex="1">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-dialog d-flex flex-column align-content-center" role="document">
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header">
                                <div class="col-01" ><button class="bt-help" @click="btHelp()"><i class="icon-help ti-help-alt"></i></button> <h5 class="modal-title">{{ title }}</h5> 
                                </div>
                                <div class="col-02" >
                                    <button type="button" class="csv-bt" aria-label="CSV" @click="btCSV()">
                                        <span class='ti-file'> CSV</span>
                                    </button>
                                </div>
                                <div class="col-03" >
                                    <button type="button" id='close-button' class="close" data-dismiss="modal" aria-label="Close" @click="showModal = false" ref="closer">
                                        <!-- <span aria-hidden="true">&times;</span> -->
                                        <span class='ti-close'></span>
                                    </button>

                                </div>                                                              
                                
                                <!-- <input id='search-input' name="query" v-model="filterKey" placeholder='type here'> -->

                                
                            </div>
                            
                            <div class="modal-body overflow-auto" style='width: 100%;'>

                                <table class='table' v-if='data.length != 0'>
                                    <thead>
                                        <tr>
                                            <th v-for="(value, key) in columns" :key='key'>
                                                <div v-if="key != 'link' && key != 'link_rci'">
                                                    <p class='table-header' @click="sortBy(key)">
                                                        {{ value | capitalize }}
                                                        <span class="arrow" v-if="sortKey == key" :class="sortKey == key ? order: ''"></span>
                                                    </p>
                                                    <br>
                                                    <input v-if="key != 'rows'" :disabled="(key == 'approved_datetime')" type="text" class='table-input' @keyup.enter="filterGrid()" v-model='sortFilters["f_" + key]'>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="entry in filteredData">
                                        <td v-for="(value, key) in columns" :key='key'>
                                        <div v-if="(key == 'report_number' && entry[key]) && (entry['report_id'] || entry['id'])">
                                            <div class="href" @click="changeModal({'link_rdp': entry['link'], 'link_rci': entry['link_rci'], 'id_rdp': entry['report_id'] || entry['id'] , 'component_id': entry['component_id'], 'technique_id': entry['technique_id'], 'technique': entry['technique'], 'ref_date': entry['ref_date'] , 'report_number': entry['report_number'] , 'plant': entry['plant'] , 'area': entry['area'] })">{{ entry[key] | handleNull }}</div>
                                        </div>
                                        <div v-else-if="key != 'link' && key != 'link_rci' && key != 'report_number'">
                                            {{ entry[key] | handleNull }}
                                        </div>
                                        <div v-else-if="key == 'report_number' && !entry['report_id']">
                                            -
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div id='spinner-loading' class="d-flex justify-content-center align-content-middle" v-if='data.length == 0'>
                                     <div class="loader"></div> 
                                </div>

                            </div>

                            <div class="modal-footer">
                                <div style="text-align:left;float:left;width:40%;">
                                {{total_pg}} / {{totalDados}} - Page: {{pg  +1}} of {{Math.round(totalDados / 30)}}

                                </div>
                                
                                <div style="float:left;width:60%;">
                                <ul class="pagination">
                                    <li class="page-item"><button class=" btn page-link" @click='pg--' :disabled='pg==0 || data.length==0'> {{ $t("158") }}</button></li>
                                    <li class="page-item"><button class="btn page-link" @click='pg++' :disabled='data.length < 30'>{{ $t("159") }}</button></li>
                                </ul>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>


    <!-- MODAL AVISO GERANDO ARQUIVO-->
    <div v-if="showModalFile" id='modal-container' @keyup.esc="showModalFile = false" tabindex="1" >
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-alert modal-dialog d-flex flex-column align-content-center" role="document" >
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header">
                                &nbsp;                                
                            </div>
                            
                            <div class="modal-body overflow-auto" style='color: #eee; font-weight: bold; height: 47px;
padding: 5px 0px;'>
                                <div class="loader loader-div"></div> 
                                <div class="txt-loader">{{ $t("160") }}</div>
                            </div>

                            <div class="modal-footer">
                                &nbsp;
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>
    <!-- FIM MODAL AVISO GERANDO ARQUIVO-->

    <!-- MODAL HELP-->
    <div v-if="showModalHelp" id='modal-container' @keyup.esc="showModalHelp = false" tabindex="1" >
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-alert modal-dialog d-flex flex-column align-content-center" role="document" >
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header header-help">
                                <div class="col-01" ><i class="icon-help ti-help-alt"></i> <span class="modal-title-help">{{ titleHelp }}</span> 
                                </div>
                                <div class="col-02" >
                                    &nbsp;
                                </div>
                                <div class="col-03" >
                                    <button type="button" id='close-button' class="close-help" data-dismiss="modal" aria-label="Close" @click="showModalHelp = false" ref="closer"><span class='ti-close'></span>
                                    </button>

                                </div>                                 
                            </div>
                            
                            <div class="modal-body overflow-auto body-help">
                                {{ txtHelp }}
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
    <!-- FIM MODAL HELP-->

  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import mixin from '../../../../utils/mixin'

export default {
    data() {
        return {
            apareceClass: false,
            total_pg: '',
            data: [],
            pg: 0,
            showModal: false,
            showModalFile: false,
            showModalHelp: false,
            title: '',
            button: '',
            columns: {},
            url: '',
            sortFilters: {},
            sortOrders: {},
            order: 'asc',
            sortKey: '',
            titleHelp: '',
            txtHelp: '',
            totalDados: '',
        }
    },
    mixins: [mixin],
    computed: {
        filteredData: function () {
            return this.data;
        },
        gridInfo: function () {
            return this.grid();
        },
    },
    filters: {
        capitalize: function (str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        handleNull: function (str){
            return str || '-';
        }
    },
    methods: {
        getData: function (pg){
            let self = this;

            const API = process.env.ROOT_API

            self.data = [];
            self.total_pg = 0

            axios({method: 'GET', url: API + this.url + '&pg=' + pg + '&sort=' + this.sortKey + '&order=' + this.order, params: this.sortFilters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
                .then(function({ data }){
                    if (data.length > 0){
                        self.data = data;
                    } else {
                        self.data = [{'-': '-'}];
                    }
                    self.pg = pg;

                    if(data.length < 30){
                        self.apareceClass = true
                    }
                    else{
                        self.apareceClass = false
                    }
                   
                    for(let i in data) {
                      self.total_pg = data[i].rows

                    }

                })
                .catch(function(error){
                    // from mixin
                    self.ApiErrorHandler(self, error.response.data.status_code);
                })
        },
        filterGrid: function () {
            this.getData(0)
        },
        sortBy: function (key) {
            if (this.sortKey != key) { this.order = 'asc' }
            else { this.order = this.order == 'desc' ? 'asc' : 'desc' }

            this.sortKey = key
            this.getData(0)
        },
        btHelp: function (){
            this.showModalHelp = true
        },
        btCSV: function (){
            let self = this;
            self.showModalFile = true
            const API = process.env.ROOT_API
            let name_chart_file = this.name_chart  
            var file = 'csv'
            axios({
              method: 'GET', 
              url: API + this.url + '&file=' + file + '&sort=' + this.sortKey + '&order=' + this.order, params: this.sortFilters, 
              responseType: 'blob',
              headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` 
            }})
            .then(function({ data }){ 
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name_chart_file+'.csv');
                document.body.appendChild(link);
                link.click();
                self.showModalFile = false
            })
            .catch(function(error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
            })  
        },
        ...mapGetters(['grid']),
        ...mapMutations(['changeModal']),
    },
    watch: {
        show: function(newValue){
            this.showModal = newValue;
        },
        url: function(newValue){
            this.url = newValue;
            this.sortFilters = {};
            this.sortKey = '';
            this.order = 'asc';
            this.getData(0);
        },
        pg: function(newValue){
            if (newValue >= 0){
                this.getData(newValue);
            }
        },
        gridInfo: function (newValue){
            this.totalDados = newValue.totalDados;
            this.title = newValue.title.toUpperCase();
            this.url = newValue.url;
            this.name_chart = newValue.name_chart;
            this.columns = newValue.columns;
            this.showModal = newValue.show;
            this.titleHelp = newValue.titleHelp;
            this.txtHelp = newValue.txtHelp;

            this.$nextTick(function () {
                this.$refs.closer.focus()
            })
        }
    },
}

</script>

<style scoped>

.apareceClass{
    display: none;
}

body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

.table {
    border-radius: 0px; 
    width: 100%;
    margin: 0;
    height: 100%;
} 

th {
    background-color: #343a40;
    color: white;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 12px;
    white-space: nowrap;
}

td {
  /* min-width: 120px; */
    padding: 10px 10px;
    white-space: nowrap;
    width: 1%;
    background-color: #343a40;
    color: white;
}

td{
    font-size: 11px;
}

tr:nth-child(even) > td {
  background-color: #454d55;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.desc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fff;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
}

#search-input{
    position: absolute;
    right: 65px;
    top: 5px;
}

.modal-mask {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
}

.modal-header{
    height: 49px;
    align-items: center;
    align-content: center;
    color: white;
}

.modal-body{
    margin: 0;
    padding: 0;
    overflow: auto;
    max-height: 80vh;
}

.modal-dialog{
    width: 90vw;
}

.modal-content{
    padding: 0;
    /* background: #1f1f20; */
    background: #2a2a2e;
    /* max-height: 80vh; */
}

.table{
    max-height: 90vh;
}

.col-01{
    width: 80%;
    float: left;
}
.col-02{
    width: 15%;
    float: left;
}
.col-03{
    width: 5%;
    float: left;
}
.csv-bt{
    outline: none;
    z-index: 10;
    float: right;
    background: #343a40;
    border-color: #343a40;
    color:
    white;
    transition: background 0.4s;
    cursor: pointer;
    margin-top: -6px;
    height: 35px;
    border-radius: 5px;
}
.csv-bt:hover{
    background: #454d55;
}

#close-button{
    outline: none;
    z-index: 10;
    margin-right: 10;
}

.ti-close{
    color: white;
    border-color: white;
    text-shadow: white;
}

.modal-footer{
    height: 50px;
    justify-content: end;
    align-items: center;
    padding: 5px 15px;
    color: white;
}

.page-link{
    background: #343a40;
    border-color: #343a40;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    margin-top: -20px;
    height: 35px;
}
.page-link:hover{
    background: #454d55;
}

.modal-title{
    color: white;
    font-weight: 100;
    font-size: 22px;
    margin: -10px 1px;
}

.table td.fit, 
.table th.fit {
    white-space: nowrap;
    width: 1%;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

#spinner-loading{
    padding: 50px 0;
}

.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #72b5e1; /* Blue */
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
  margin: 0 auto;
}
.loader-div{
    float: left;
    margin-left: 22%;
    margin-right: 5%;

}
.txt-loader{
    padding-top: 8px;
}
.modal-alert{
    width: 30% !important;
}
.bt-help{
    float: left;
    margin-top: -3px;
    margin-left: -10px;
}
.modal-title-help{
    font-weight: bold;
    font-size: 16px;
}
.close-help{
    background: no-repeat;
    border: none;
    margin-left: -10px;
}
.header-help{
    border: 1px solid #134F69;
    height: 35px;
    background-color: #627c88;
    font-weight: bold;
    padding: 5px 5px;
    color: #ccc;
}
.body-help{
    color: #eee; 
    height: auto; 
    padding: 5px 5px;
}

.href{
  color: #68B3C8;
  cursor: pointer;
}


@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 770px) {
    .modal-dialog {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
    }
    .modal-alert{
        width: 100% !important;
    }
}

.table-input{
    width: 100%;
    height: 25px;
    font-size: 14px;
    padding: auto auto;
}

.table-header{
    margin: 0 auto;
    padding: 0;
    margin-bottom: -20px;   
}


 @media screen and (max-width: 700px) {
    .modal-body{
        max-height: 60vh;
    }
 }
 @media screen and (max-width: 650px) {
    .modal-title{
      font-size: 14px;
      margin-top: -3px;
    }
    .modal-body{
        max-height: 60vh;
    }
 }
 @media screen and (max-width: 420px) {
    .col-01{
        width: 62%;
    }
    .col-02{
        width: 30%;
    }
    .col-03{
        width: 8%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/Grid.vue